import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CarouselComponent, CarouselModule, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { CatlougeTypeConstants } from '../../core/constants';
import { customOptionsForBigSlider, customOptionsForEightMiniSlider, customOptionsForFourMiniSlider, customOptionsForSevenMiniSlider, customOptionsForSixMiniSlider, customOptionsForThreeMiniSlider, customOptionsForFiveMiniSlider } from '../../shared/owl-slider-config';

import moment from 'moment-timezone';
import { CommonService } from '../../core/services/common.service';
import { CommonModule } from '@angular/common';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-category',
  imports: [CommonModule,ImageManipulationComponent,CarouselModule, TranslateModule],
  templateUrl: './category.component.html',
  styleUrl: './category.component.css'
})
export class CategoryComponent {

  @Input() owlOption!: OwlOptions;
  @Input() data: any = {};

  customOptionsForBigSlider = customOptionsForBigSlider;
  customOptionsForFourMiniSlider = customOptionsForFourMiniSlider;
  customOptionsForFiveMiniSlider = customOptionsForFiveMiniSlider;
  customOptionsForSevenMiniSlider = customOptionsForSevenMiniSlider;
  customOptionsForSixMiniSlider = customOptionsForSixMiniSlider;
  customOptionsForThreeMiniSlider = customOptionsForThreeMiniSlider;
  customOptionsForEightMiniSlider = customOptionsForEightMiniSlider;


  assets_hover: boolean = false;
  userInfo: any;
  page_view: string = '';
  routeName: string = '';
  playListId: string = '';
  setPlayListItem: any;
  addedAssetIndex: any;
  error_code: any;
  deletedItem: any;
  deleteAsset_id: any;

  thumbnailType: any;
  thumbnailClass: string ='';
  notFoundImg: string = 'image-not-found';
  assetImgParam: any;
  categoryId: any;
  viewAllType: any;
  limit: number = 20;

  isCircle: any;
  enlargedCircle: any;
  blankSliderCount!: number;
  owlSlides: boolean = false;
  hoverParams: any = { "crop": 'fill', 'width': 304, 'height': 171 };
  firstSlideIndex!: number;
  lastSlideIndex!: number;
  showViewAll: number = 4;
  @ViewChild('owlCarousel', { static: false }) owlCarousel!: CarouselComponent;
  @ViewChild('owlCarouselEl', { read: ElementRef }) owlCarouselEl!: ElementRef;


  constructor(
    public router: Router,
    public commonService: CommonService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {


    this.data = this.data;

    this.thumbnailType = this.data.thumbnail_type.slug;

    switch (this.thumbnailType) {
      case 'landscape':
        this.owlOption = customOptionsForFiveMiniSlider;
        this.assetImgParam = {'width': 304, 'height': 171 };
        this.thumbnailClass = 'landscape_assets';
        this.notFoundImg = 'landscape';
        this.showViewAll = 5;
        break;
      case 'enlarged-landscape':
        this.owlOption = customOptionsForFourMiniSlider;
        this.assetImgParam = {'width': 400, 'height': 225 };
        this.thumbnailClass = 'enlarged_landscape_assets';
        this.notFoundImg = 'enlarged_landscape';
        this.showViewAll = 4;
        break;
      case 'stretched-landscape':
        this.owlOption = customOptionsForFourMiniSlider;
        this.assetImgParam = { 'width': 368, 'height': 161 };
        this.thumbnailClass = 'stretched_landscape_assets';
        this.notFoundImg = 'stretched_landscape';
        this.showViewAll = 5;
        break;
      case 'portrait':
        this.owlOption = customOptionsForSevenMiniSlider;
        this.assetImgParam = { 'width': 220, 'height': 330 };
        this.thumbnailClass = 'portrait_assets';
        this.notFoundImg = 'portrait';
        this.showViewAll = 7;
        break;
      case 'square':
        this.owlOption = customOptionsForSevenMiniSlider;
        this.assetImgParam = { 'width': 220, 'height': 220 };
        this.thumbnailClass = 'square_assets';
        this.notFoundImg = 'square';
        this.showViewAll = 7;
        break;
      case 'enlarged-square':
        this.owlOption = customOptionsForFiveMiniSlider;
        this.assetImgParam = { 'width': 320, 'height': 320 };
        this.thumbnailClass = 'enlarged_square_assets';
        this.notFoundImg = 'enlarged_square';
        break;
      case 'circular':
        this.owlOption = customOptionsForSevenMiniSlider;
        this.assetImgParam = { 'width': 220, 'height': 220 };
        this.thumbnailClass = 'circular_assets';
        this.notFoundImg = 'circle';
        this.showViewAll = 7;
        break;
      case 'enlarged-circle':
        this.owlOption = customOptionsForSixMiniSlider;
        this.assetImgParam = { 'width': 320, 'height': 320 };
        this.thumbnailClass = 'enlarged-circular_assets';
        this.notFoundImg = 'circle';
        this.showViewAll = 5;
        break;

      default: this.thumbnailClass = 'landscape_assets';
        this.assetImgParam = { 'width': 304, 'height': 171 };
        this.owlOption = customOptionsForFiveMiniSlider;
        this.notFoundImg = 'landscape';
        this.showViewAll = 5;
        break;
    }

    this.blankSliderCount = this.owlOption.items! - this.data.sub_categories.length;

    // this.owlSlides = this.data.sub_categories && this.data.sub_categories.length >= 4 ? true : false;


  }

  onCarouselInitialized(event: SlidesOutputData) {
    this.firstSlideIndex = event.startPosition!;
    this.lastSlideIndex = event.startPosition! + this.owlOption.items! - 1;
    
    setTimeout(() => {
      const allSlides = this.owlCarouselEl.nativeElement.querySelectorAll('.owl-stage .owl-item');

      allSlides.forEach((slide:any, index:any) => {
        this.renderer.removeClass(slide, 'firstActiveItem');
        this.renderer.removeClass(slide, 'lastActiveItem');
        if (this.firstSlideIndex == index) {
          this.renderer.addClass(slide, 'firstActiveItem');
        }
        if (this.lastSlideIndex == index) {
          this.renderer.addClass(slide, 'lastActiveItem');
        }
      });
    }, 100);
  }

  // counter(count: number): any[] {
  //   return Array(count).fill(0).map((x, i) => i);
  // }

  onCarouselTranslated(event: SlidesOutputData) {
    if (
      this.firstSlideIndex == event.startPosition &&
      this.lastSlideIndex == event.startPosition + this.owlOption.items! - 1
    ) {
      return;
    }
    this.firstSlideIndex = event.startPosition!;
    this.lastSlideIndex = event.startPosition! + this.owlOption.items! - 1;

    const allSlides = this.owlCarouselEl.nativeElement.querySelectorAll('.owl-stage .owl-item');

    allSlides.forEach((slide:any, index:any) => {
      this.renderer.removeClass(slide, 'firstActiveItem');
      this.renderer.removeClass(slide, 'lastActiveItem');
      if (this.firstSlideIndex == index) {
        this.renderer.addClass(slide, 'firstActiveItem');
      }
      if (this.lastSlideIndex == index) {
        this.renderer.addClass(slide, 'lastActiveItem');
      }
    });
  }


  counter(count: number): any[] {
    if(count >0) {
      return Array(count).fill(0).map((x, i) => i);
    }else {
      return []
    }
   
  }

  redirectUrl(data:any) {
    let viewAlldParams:any = {
      categoryId: data._id,
    }

    viewAlldParams['type'] = this.data.tab_slug;
    let viewalltabDataParams = {
      "plateform": "web",
      "catlogue": CatlougeTypeConstants.catlogue,
      "slug": this.data.tab_slug,
      "call": 'index',
      "page": 1,
      "limit": this.limit
    };
    this.router.navigate(['/subcategory'], { queryParams: viewAlldParams })

    
  }
  
  viewall(data:any) {
    console.log(data);
    let viewAlldParams:any = {
      categoryId: data.category_mongo_id,
      categoryType: data.category_type,
      subCategoryCount: data.sub_category_count
    }

    viewAlldParams['type'] = data.tab_slug;
    this.router.navigate(['/viewall'], { queryParams: viewAlldParams })
  }

  item_hover_enter() {
    this.assets_hover = true;
  }

  item_hover_leave() {
    this.assets_hover = false;
  }
}
